import { render, staticRenderFns } from "./MenuPricing.vue?vue&type=template&id=ebc3e670&scoped=true&"
import script from "./MenuPricing.vue?vue&type=script&lang=js&"
export * from "./MenuPricing.vue?vue&type=script&lang=js&"
import style0 from "./MenuPricing.vue?vue&type=style&index=0&id=ebc3e670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc3e670",
  null
  
)

export default component.exports